/*!
 * Solva Advertorial — Sticky CTA reveal
 * Keeps the fixed bottom CTA bar hidden until the reader reaches the
 * first in-article CTA block ([data-solva-adv-cta]). Once revealed it
 * stays visible. If no CTA block exists, the bar is shown immediately.
 */
(function () {
  if (typeof document === 'undefined') return;

  var bar = document.querySelector('.solva-advsticky--reveal');
  if (!bar) return; // reveal mode off — bar is always visible, nothing to do

  function reveal() {
    bar.classList.add('is-revealed');
    bar.setAttribute('aria-hidden', 'false');
  }

  var firstCta = document.querySelector('[data-solva-adv-cta]');
  if (!firstCta) { reveal(); return; }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal();
          io.disconnect();
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(firstCta);
  } else {
    // Fallback: reveal once the first CTA is scrolled into view
    var onScroll = function () {
      var r = firstCta.getBoundingClientRect();
      if (r.top < window.innerHeight) {
        reveal();
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
